import { forwardRef, createElement } from 'react';

function IconRotateRight(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M12 2.75a9.25 9.25 0 019.245 8.944l.725-.724a.75.75 0 01.976-.073l.084.073a.75.75 0 01.073.976l-.073.084-2 2a.75.75 0 01-.976.073l-.084-.073-2-2a.75.75 0 01.976-1.133l.084.073.714.712A7.75 7.75 0 106.52 17.48a.75.75 0 11-1.06 1.06A9.25 9.25 0 0112 2.75z",
    fill: "currentColor"
  }));
}

var RotateRight = /*#__PURE__*/forwardRef(IconRotateRight);

export default RotateRight;
//# sourceMappingURL=RotateRight.js.map
